export {default as ClientJourney} from './ClientJourney.connect';
